import { MapPin, Phone, MessageCircle, Instagram, Mail } from "lucide-react";
import { CONTACT, WHATSAPP_TRAINING_HREF } from "../lib/contact";

export default function Contact() {
  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-10 py-14 lg:py-20" data-testid="page-contact">
      <div className="eyebrow">İletişim</div>
      <h1 className="font-serif mt-4 text-4xl lg:text-5xl font-semibold leading-[1.08]">Konuşmaya her zaman açığız.</h1>
      <p className="mt-4 max-w-2xl text-[color:var(--em-espresso-soft)]">
        Eğitim takvimi, grup kontenjanı veya sipariş detayları için en hızlı yanıt WhatsApp
        üzerinden. Dilerseniz doğrudan arayabilirsiniz.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        <ContactCard icon={MapPin} title="Konum" value={`${CONTACT.locationLine1}, ${CONTACT.locationLine2}`} testId="contact-location" />
        <ContactCard icon={Phone} title="Telefon" value={CONTACT.phoneDisplay} href={CONTACT.phoneHref} ctaLabel="Ara" testId="contact-phone" />
        <ContactCard icon={MessageCircle} title="WhatsApp" value="Hızlı yanıt için önerilir" href={WHATSAPP_TRAINING_HREF} ctaLabel="WhatsApp'tan Yaz" testId="contact-whatsapp" external />
        <ContactCard icon={Instagram} title="Instagram" value={CONTACT.instagramHandle} href={CONTACT.instagramHref} ctaLabel="Instagram'da Takip Et" testId="contact-instagram" external />
      </div>
    </div>
  );
}

function ContactCard({ icon: Icon, title, value, href, ctaLabel, testId, external }) {
  return (
    <div className="rounded-sm border p-6 lg:p-8" style={{ borderColor: "var(--em-border)", background: "var(--em-stone)" }} data-testid={testId}>
      <div className="inline-flex items-center justify-center w-11 h-11 rounded-full" style={{ background: "var(--em-terracotta-light)", color: "var(--em-terracotta-hover)" }}>
        <Icon size={20} />
      </div>
      <div className="mt-5 font-serif text-xl font-semibold">{title}</div>
      <div className="mt-2 text-sm text-[color:var(--em-espresso-soft)]">{value}</div>
      {href && (
        <a
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          className="btn-terracotta mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold"
          data-testid={`${testId}-cta`}
        >
          {ctaLabel}
        </a>
      )}
    </div>
  );
}
